'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LabelCheckboxDocs = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Checkbox = require('./Checkbox');

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _withSwitchLabel = require('../internal/withSwitchLabel');

var _withSwitchLabel2 = _interopRequireDefault(_withSwitchLabel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LabelCheckbox = (0, _withSwitchLabel2.default)(_Checkbox2.default);

var _ref = _react2.default.createElement('span', null);

var LabelCheckboxDocs = exports.LabelCheckboxDocs = function LabelCheckboxDocs() {
  return _ref;
};

LabelCheckboxDocs.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * If `true`, the control will be disabled.
   */
  disabled: _propTypes2.default.bool,
  /**
   * The text to be used in an enclosing label element.
   */
  label: _propTypes2.default.node,
  /**
   * The className to be used in an enclosing label element.
   */
  labelClassName: _propTypes2.default.string
} : {};

exports.default = LabelCheckbox;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui/Checkbox/LabelCheckbox.js
// module id = 445
// module chunks = 0